import React from 'react';
import { Pagination, Table } from 'antd';
import _ from 'lodash';
import DescriptioinTable from './DescriptionTable';
import moment from 'moment';


const TicketStatusTable = ({ ticketDashboard, fetchTicketDashboardData, selectedSubcat, userData, startDate, endDate }) => {
  const { dashboardData, rowCount } = ticketDashboard;
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Open',
      dataIndex: 'open',
      key: 'open',
    },
    {
      title: 'Closed',
      dataIndex: 'close',
      key: 'close',
    },
    {
      title: 'Pending',
      dataIndex: 'pending',
      key: 'pending',
    },
    {
      title: 'Resolved',
      dataIndex: 'resolved',
      key: 'resolved',
    }
  ]

  const dataToMap = dashboardData?.map((user) => {
    return {
      key: user._id,
      name: user.name,
      open: user.total_open,
      close: user.total_closed,
      resolved: user.total_resolved,
      pending: user.total_pending,
      description: <DescriptioinTable data={user.subCategories} lastTenDaysData={user.tenDaysData} />
    }
  });
  return <>
    <Table
      pagination={false}
      columns={columns}
      expandable={{
        expandedRowRender: (record) => (
          <div
            style={{ margin: 5 }}
          >
            {record.description}
          </div>
        ),
        rowExpandable: (record) => record.name !== 'Not Expandable',
      }}
      dataSource={dataToMap || []}
    />
    <div className='d-flex justify-content-end py-3'>
      <Pagination defaultCurrent={1} total={rowCount} onChange={(page) => {
        fetchTicketDashboardData({
          startDate: moment(startDate.format()).startOf('day'),
          endDate: moment(endDate.format()).endOf('day'),
          subCategory: selectedSubcat,
          user: userData,
          pageNumber: page
        })
      }} />
    </div>
  </>
};

export default TicketStatusTable

